<template>
  <div class="panel-content countDown-make-sentence-root">
    <question-description
      :currItem="currItem"
      :code="currItem.topic_type"
      :style="{ width: isExamMode ? '586px' : '700px' }"
    ></question-description>

    <!-- <div class="score-content" v-if="isShowScores">
      {{ $t('evaluate_common_total_score') }}:
      <span :style="{ color: currItem.scores / currItem.score >= 0.8 ? '#09cba0' : '#fc5a5a' }">{{
        isMarked == 2 ? currItem.scores : '-'
      }}</span
      >{{ `/${currItem.score}` }}
    </div> -->

    <div class="language-select-con" v-if="currItem.topic_type == 'tr'">
      <p class="title">{{ $t('edit_message_language') }}</p>
      <el-select
        v-model="translationLanguage"
        size="small"
        @change="changeLanguage"
        class="language-select"
      >
        <el-option
          v-for="item in languageList"
          :key="item.value"
          :label="item.title"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 渲染普通的screen-text下内容 -->
    <div class="panel-content-text" :style="{ paddingTop: isExamMode ? '50px' : '20px' }">
      <div
        v-for="(item, itemIndex) in currItem.screen_text"
        :key="currItem.index + itemIndex"
        class="text-con"
      >
        <p class="question-stem-text" v-if="item.type == 'text'">
          {{ item.content }}
        </p>
        <img
          v-else-if="item.type == 'image'"
          :src="baseUrl + item.content + '?width=1500'"
          alt=""
        />
      </div>
    </div>
    <!-- 题号 -->
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t('hsk_example') : currItem.index }}
    </div>
    <!-- 渲染翻译多语言题干内容 -->
    <div class="translation-question-stem" v-html="translationStem"></div>
    <div class="panel-content-input">
      <el-input
        v-if="isExamMode"
        type="textarea"
        :rows="computedRows"
        :placeholder="inputPlaceholder"
        v-model="inputText"
        :maxlength="limitLength"
        @input="textInput"
        :disabled="currItem.is_example"
      >
      </el-input>
      <p v-if="!isExamMode" class="limit">
        <span>{{ $t('hsk_write_count') }}</span
        >{{ wordLengthUnExamMode }}
      </p>
      <p v-if="isExamMode && currItem.topic_type !== 'tr'" class="limit">
        <span>{{ $t('hsk_write_count') }}</span
        >{{ wordLength }}
      </p>
      <div v-else-if="!isExamMode" class="input-box" v-html="currItem.answer || inputText"></div>
    </div>
    <div class="panel-content-result" v-if="!isExamMode && !currItem.is_example">
      <p class="orange">{{ $t('hsk_reference_answer') }}</p>
      <p
        class="correct-answer"
        v-for="(txt, key) in currItem.evaluate.standard_answer"
        :key="key + currItem.index"
      >
        {{ txt }}
      </p>
    </div>
    <div class="correct-box" v-if="!isExamMode && analysisText && !currItem.is_example">
      <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
      <p class="correct-box-answer">
        {{ analysisText }}
      </p>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { getAllWordsLength } from '@/utils/utils'
import { getLanguageSelectList, getScreenTextByLanguage } from '@/utils/hskTool'
import { mapGetters, mapState } from 'vuex'
export default {
  components: { QuestionDescription },
  data() {
    return {
      inputText: '',
      blankNum: 0,
      languageList: [],
      translationLanguage: '',
      translationStem: '',
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    analysisText() {
      return this.currItem.analysis
        ? this.currItem.analysis[this.language]
          ? this.currItem.analysis[this.language]
          : this.currItem.analysis['zh']
        : ''
    },
    answerText() {
      return this.currItem.evaluate.standard_answer[0]
    },
    imageScreenText() {
      return this.currItem.screen_text.filter((item) => {
        return item.type == 'image'
      })
    },
    limitLength() {
      return this.currItem.answer_limit
    },
    computedRows() {
      if (this.currItem.topic_type == 'pu') {
        // 材料写作
        if (this.currItem.answer_limit == '400') {
          return 8
        } else if (this.currItem.answer_limit == '1200') {
          return 19
        }
      }
      return 5
    },
    inputPlaceholder() {
      if (this.currItem.topic_type == 'pu') {
        // 材料写作
        return this.$t('hsk_write_by_artical')
      } else if (this.currItem.topic_type == 'tr') {
        return this.$t('hsk_translation_by_artical')
      }
      return this.$t('hsk_input_type_here')
    },
    isShowScores() {
      return !this.currItem.is_example && !this.isExamMode && !this.$route.query?.ifRecord
    },
    wordLength() {
      return getAllWordsLength(this.inputText)
    },
    wordLengthUnExamMode() {
      return getAllWordsLength(this.currItem.answer)
    },
    ...mapState({
      storeTranslationLanguage: (state) => state.simulation.storeTranslationLanguage,
    }),
  },
  watch: {
    currItem: {
      handler(val) {
        console.log(val, 'get change val')
        if ((val.screen_text && val.screen_text.length > 0) || val.screen_text_trans) {
          if (val.answer) {
            if (this.isExamMode) {
              this.inputText = val.answer
            }
          } else {
            if (this.currItem.is_example) {
              this.inputText = this.isExamMode
                ? val.evaluate.standard_answer[0]
                : this.changeColor(val.evaluate.standard_answer[0], this.keywordsdetail)
            } else {
              this.inputText = ''
            }
          }
        }
        if (val.topic_type == 'tr') {
          // 如果是翻译，需要初始化多语言列表，展示对应的多语言题干
          this.languageList = getLanguageSelectList(this.currItem.screen_text_trans)
          this.translationLanguage =
            sessionStorage.getItem('translationLanguage') || this.languageList[0].value
          this.translationStem = getScreenTextByLanguage(
            this.currItem.screen_text_trans,
            this.translationLanguage
          )
        }
      },
      immediate: true,
    },
    storeTranslationLanguage: {
      handler(val) {
        this.translationLanguage = val
        this.changeLanguage()
      },
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    baseUrl: {
      type: String,
      default: '',
    },
    // 批改状态
    isMarked: {
      type: Number,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    changeLanguage() {
      this.translationStem = getScreenTextByLanguage(
        this.currItem.screen_text_trans,
        this.translationLanguage
      )
      sessionStorage.setItem('translationLanguage', this.translationLanguage)
    },
    //输入框监听
    textInput(e) {
      this.inputText = e
      let inputText = e.replace(/\ +/g, '')
      inputText = inputText.replace(/[\r\n]/g, '')
      // if (inputText.length > 8) {
      //   layer.msg('超了')
      // }
      this.blankNum = e.length - inputText.length
      this.textChange()
    },
    //失焦暂存
    textChange() {
      let ansObj = {
        questionId: this.currItem.index,
        answer: this.inputText,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
        evaluate: {
          category: this.currItem.evaluate.category,
          answer: this.inputText,
          full_marks: this.currItem.score,
          reference_answer: JSON.stringify(this.currItem.evaluate.standard_answer),
          unnecessary_keywords: JSON.stringify(this.currItem.evaluate.key_words_optional),
          original_text: '',
          questionId: this.currItem.index,
        },
      }
      console.log(ansObj)
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    changeColor(result, keywords) {
      keywords.map((keyitem, keyindex) => {
        if (keyitem && keyitem.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(keyitem, 'g') // 高亮替换v-html值
          let replaceString =
            '<span class="highlight"' + ' style="color: #1C84FE' + ';">' + keyitem + '</span>'
          result = result.replace(replaceReg, replaceString)
        }
      })

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 35px 29px 20px 29px;
  position: relative;
  .language-select-con {
    position: absolute;
    top: -60px;
    right: 100px;
    .title {
      color: #b5b5be;
      font-size: 12px;
      margin-bottom: -2px;
      position: relative;
      z-index: 100;
    }
    .language-select {
      width: 170px;
    }
  }
  .score-content {
    position: absolute;
    right: 23px;
    top: 16px;
  }

  .question_require {
    position: absolute;
    left: 0px;
    top: 45px;
    font-size: 12px;
    font-weight: 400;
    color: #3f4651;
    margin-top: 0px;
  }
  &-text {
    padding-top: 50px;

    .text-con {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-bottom: 24px;
    }
    img {
      width: 100%;
      text-align: center;
      margin: auto;
      border-radius: 4px;
      object-fit: contain;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #696974;
    }
  }

  .example {
    background: #3f4651;
    border-radius: 4px;
    color: #fff;
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    text-align: center;
  }
  .translation-question-stem {
    margin-top: 16px;
    color: #696974;
    font-size: 14px;
    line-height: 20px;
  }
  &-input {
    margin: 20px 0px 40px 0px;
    position: relative;
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #696974;
      margin-right: 7px;
      span {
        color: #b5b5be;
        margin-right: 4px;
      }
    }
    .input-box {
      padding: 5px 15px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      min-height: 100px;
      line-height: 21px;
    }
  }
  &-result {
    width: 100%;
    border-top: 1px dashed #e6eaef;
    padding: 30px 0px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      margin-top: 20px;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
    }
  }
  .correct-box {
    background: rgba(251, 252, 255, 1);
    border: 1px solid rgba(242, 243, 247, 1);
    border-radius: 10px;
    padding: 20px;

    &-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(63, 70, 81, 1);
      margin-bottom: 10px;
    }
    &-answer {
      font-size: 14px;
      font-weight: 400;
      color: rgba(84, 89, 97, 1);
      line-height: 21px;
      white-space: pre-line;
    }
  }
}
.part-count-down-con {
  position: absolute;
  top: 16px;
  right: 15px;
}
::v-deep .language-select-con .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #b5b5be !important;
  color: #2c2f46;
  padding: 0 15px 0 0;
  border-radius: 0;
}
::v-deep .language-select-con .el-select .el-input .el-select__caret {
  font-weight: bold;
}
</style>
